/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonStratUserInfo,
    JsonStratUserInfoFromJSON,
    JsonStratUserInfoFromJSONTyped,
    JsonStratUserInfoToJSON,
} from './JsonStratUserInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonStratUserInfo
 */
export interface ApiResultOfListOfJsonStratUserInfo {
    /**
     * 
     * @type {Array<JsonStratUserInfo>}
     * @memberof ApiResultOfListOfJsonStratUserInfo
     */
    data?: Array<JsonStratUserInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonStratUserInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonStratUserInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonStratUserInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonStratUserInfo
     */
    result?: ApiResultOfListOfJsonStratUserInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonStratUserInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonStratUserInfoFromJSON(json: any): ApiResultOfListOfJsonStratUserInfo {
    return ApiResultOfListOfJsonStratUserInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonStratUserInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonStratUserInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonStratUserInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonStratUserInfoToJSON(value?: ApiResultOfListOfJsonStratUserInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonStratUserInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

